import {
  VerifyAndTransitionModelEnum,
  useGetConfigurationQuery,
  useVerifyAndTransitionStatusMutation,
} from '@/types/generated/graphql';
import { FALLBACK_MAX_CALL_DURATION } from '@modules/phone/constants/transition-call-status.constants';
import { useTransitionCallStatusStore } from '@modules/phone/store/transition-call-status.store';
import dayjs from 'dayjs';

export const useTransitionCallStatus = () => {
  const [transitionStatus] = useVerifyAndTransitionStatusMutation();
  const { data } = useGetConfigurationQuery({
    nextFetchPolicy: 'cache-only',
    variables: {
      key: 'maximum-call-duration',
    },
  });
  const maxCallDuration = data?.getConfiguration?.data?.['maximum-call-duration'] || FALLBACK_MAX_CALL_DURATION;

  async function transitionStatusHelper(
    messageIds: number[],
    model: VerifyAndTransitionModelEnum = VerifyAndTransitionModelEnum.MessageConversation
  ) {
    if (messageIds?.length === 0) return;
    for (const messageId of messageIds) {
      try {
        const store = useTransitionCallStatusStore.getState();
        const existingTimestamp = store.messageIds[messageId];
        if (existingTimestamp && dayjs().diff(existingTimestamp, 'seconds') < maxCallDuration) continue;
        store.appendMessageId(messageId);
        await transitionStatus({
          variables: { verifyAndTransitionStatusId: messageId, model },
        });
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }

  return {
    maxCallDuration,
    transitionStatusHelper,
  };
};
